module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAWCAYAAAD9091gAAAAAXNSR0IArs4c6QAAAOFJREFUKFPt0qFKQ2EYxvH/AztjK4NjF8FqM7ngHWwMBysLBpE1QVbMXoBNFkSjQQYHDt+pwoJoMogXYDxtYWVj4HnEMJxnF2Dxa+/HL73vX+52d1guA9K1Qrih9ORWax+YIN0qhOEmaLf3sF/+wZ/swb3eFvP5trLsTS7dwv1+zGyWIO0SRQe/ALXaJYvFFfYJMCKOL9bBHfYn0jn2A/X6mcbj6Q+AV6AJPFKtnipJ8u82VuAZaCA9AccK4WMVjtzpHFIUKUUxpVI5Upq+r1clDwYReT7CvleWTTaSK3+U5y+9X6+Xf7M5fgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/data_down_arrow.png
// module id = nrxO
// module chunks = 1